export default __webpack_public_path__ + "static/premio1_DO-baef2dd240ea035a224bd1f5148ddde1.png";